<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6">
      <AppInputField
        id="companyName"
        name="name"
        label="Razón social:"
        left-icon="label"
        placeholder="Machete SA de CV"
        :value="companyName"
        :loading="loading"
        :disabled="loading"
        required
        @input="onChangeCompany"
        @change="onChangeCompany"
      />
    </div>

    <div class="column is-12-mobile is-6">
      <AppInputRfc
        :value="rfc"
        :disabled="loading"
        :loading="loading"
        :valid-icon="false"
        required
        @input="onChangeRfc"
        @change="onChangeRfc"
      />
    </div>

    <div class="column is-12-mobile is-6">
      <AppInputEmail
        :value="email"
        :disabled="loading"
        :loading="loading"
        required
        @input="onChange"
        @change="onChange"
      />
    </div>

    <div class="column is-12-mobile is-6">
      <AppInputPhoneNumber
        :value="phoneNumber"
        :disabled="loading"
        :loading="loading"
        :valid-icon="false"
        @input="onChange"
        @change="onChange"
      />
    </div>

    <div class="column is-12-mobile is-6">
      <AppInputPassword
        :value="password"
        :disabled="loading"
        :loading="loading"
        required
        @input="onChange"
        @change="onChange"
      />
    </div>

    <div class="column is-12-mobile is-6">
      <AppInputPassword
        id="passwordConfirmation"
        name="passwordConfirmation"
        label="Repetir Contraseña"
        error-message="Las contraseñas no coinciden"
        :value="passwordConfirmation"
        :pattern="password"
        :loading="loading"
        :disabled="loading"
        required
        @input="onChange"
        @change="onChange"
      />
    </div>

    <div
      v-if="referCode"
      class="column is-12-mobile is-6"
    >
      <AppInputField
        id="referencedCode"
        name="referencedCode"
        label="Código de referencia"
        left-icon="label"
        placeholder="E01DXA"
        :value="referencedCode"
        :loading="loading"
        :disabled="loading"
        @input="onChange"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import capitalize from 'lodash/capitalize';
import upperFirst from 'lodash/upperFirst';
import merge from 'lodash/merge';
import {
  mapState,
  mapMutations,
} from 'vuex';

export default {
  name: 'SignUpWithRfc',
  components: {
    AppInputField: () => import(/* webpackChunkName: "app-input-field" */ '@/components/AppInputField.vue'),
    AppInputEmail: () => import(/* webpackChunkName: "app-input-email" */ '@/components/AppInputEmail.vue'),
    AppInputPassword: () => import(/* webpackChunkName: "app-input-password" */ '@/components/AppInputPassword.vue'),
    AppInputRfc: () => import(/* webpackChunkName: "app-input-rfc" */ '@/components/AppInputRfc.vue'),
    AppInputPhoneNumber: () => import(/* webpackChunkName: "app-input-phone" */ '@/components/AppInputPhoneNumber.vue'),
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    referCode: {
      type: Boolean,
      default: false,
    },
  },
  computed: mapState({
    tradeName: ({ company }) => company.tradeName,
    companyName: ({ company }) => company.name,
    name: ({ auth }) => auth.name,
    email: ({ auth }) => auth.email,
    rfc: ({ company }) => company.rfc,
    phoneNumber: ({ auth }) => auth.phoneNumber,
    password: ({ auth }) => auth.password,
    passwordConfirmation: ({ auth }) => auth.passwordConfirmation,
    referencedCode: ({ auth }) => auth.referencedCode,
  }),
  mounted() {
    const {
      firstname = '',
      lastname = '',
      businessname = '',
      rfc = '',
      email = '',
      phone = '',
      referencedCode = '',
    } = this.$route.query;

    const name = firstname && lastname ? `${firstname} ${lastname}` : firstname || lastname;

    this.$store.commit('auth/setValues', {
      name,
      email,
      phoneNumber: phone,
      referencedCode,
    });

    this.$store.commit('company/setValues', {
      name: businessname,
      rfc,
    });
  },
  beforeDestroy() {
    this.$store.commit('auth/cleanSensitiveData');
  },
  methods: merge(
    mapMutations({
      setAuthValue: 'auth/setValue',
      setCompanyValue: 'company/setValue',
    }),
    {
      onChangeName(event) {
        const { name: accessor, value: plainValue } = event.target;

        const value = plainValue.split(' ').map(capitalize).join(' ');

        this.setAuthValue({ accessor, value });
      },
      onChangeCompany(event) {
        const { name: accessor, value: plainValue } = event.target;

        const value = plainValue.split(' ').map(upperFirst).join(' ');

        this.setCompanyValue({ accessor, value });
      },
      onChangeEmail(event) {
        const { name: accessor, value } = event.target;

        this.setAuthValue({ accessor, value });
      },
      onChangeRfc(event) {
        const { name: accessor, value } = event.target;

        this.setCompanyValue({ accessor, value });
      },
      onChange(event) {
        const { name: accessor, value } = event.target;
        this.setAuthValue({ accessor, value });
      },
    },
  ),
};
</script>

<style scoped>
</style>
